import axiosInstance from "@/lib/axios";

export const planService = {
  getPlans: async (params = {}) => {
    const response = await axiosInstance.get("/api/v1/admin/plans", { params });
    return response.data;
  },

  createPlan: async (data) => {
    const response = await axiosInstance.post("/api/v1/admin/plans", data);
    return response.data;
  },

  updatePlan: async (id, data) => {
    const response = await axiosInstance.put(`/api/v1/admin/plans/${id}`, data);
    return response.data;
  },

  deletePlan: async (id) => {
    const response = await axiosInstance.delete(`/api/v1/admin/plans/${id}`);
    return response.data;
  },
};
